module.exports = __webpack_public_path__ + "static/media/shield.0d76dc6e.svg";